import { useTranslations } from 'next-intl';

import useMembershipPricing from '@/app/hooks/useMembershipPricing';

export function PopMembershipIntro(): JSX.Element {
  const t = useTranslations();
  const membershipPricingValues = useMembershipPricing({
    footnoteSymbol: '***',
  });

  return <div>{t.rich('pop_membership_copy', membershipPricingValues)}</div>;
}
